import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import GetInvolvedPage from "@/pages/GetInvolvedPage";
import CareersPage from "@/pages/CareersPage";
import SustainabilityPage from "@/pages/SustainabilityPage";
import ExplorePage from "@/pages/ExplorePage";
import ChatWidget from "@/components/ChatWidget";
import { IntroRequestDialog } from "@/components/jobs/IntroRequestDialog";
import { AuthDialog } from "@/components/AuthDialog";
import WirePage from "@/pages/WirePage";
import CaseStudyPage from "@/pages/CaseStudyPage";
import DecksPage from "@/pages/DecksPage";
import MyJobsPage from "@/pages/MyJobsPage";
import MagicLinkPage from "@/pages/MagicLinkPage";
import AcademyPage from "@/pages/AcademyPage";
import HeroOptionsPage from "@/pages/HeroOptionsPage";
import LandingOptionsPage from "@/pages/LandingOptionsPage";
import AuthCallback from "@/components/AuthCallback";
import { AuthProvider } from "@/lib/auth";
import { SavedJobsProvider } from "@/lib/useSavedJobs";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  if (location.pathname === "/" && location.hash === "#case-study") return <Navigate to="/case-study" replace />;
  if (location.pathname === "/" && window.location.hostname.endsWith("dcyb.academy")) return <Navigate to="/academy" replace />;
  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/get-involved" element={<GetInvolvedPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/sustainability" element={<SustainabilityPage />} />
        <Route path="/explore" element={<ExplorePage />} />
        <Route path="/wire" element={<WirePage />} />
        <Route path="/case-study" element={<CaseStudyPage />} />
        <Route path="/decks" element={<DecksPage />} />
        <Route path="/academy" element={<AcademyPage />} />
        <Route path="/hero-options" element={<HeroOptionsPage />} />
        <Route path="/landing-options" element={<LandingOptionsPage />} />
        <Route path="/my-jobs" element={<MyJobsPage />} />
        <Route path="/auth/magic" element={<MagicLinkPage />} />
      </Routes>
      <ChatWidget />
      <IntroRequestDialog />
      <AuthDialog />
    </>
  );
}

function App() {
  return (
    <div className="App grain min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <SavedJobsProvider>
            <AppRouter />
          </SavedJobsProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            border: "1px solid #D2D5DA",
            borderRadius: 0,
            color: "#0F1117",
            fontFamily: "Outfit, sans-serif",
            boxShadow: "0 10px 24px rgba(15,17,23,0.08)",
          },
        }}
      />
    </div>
  );
}

export default App;
